import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="section-container flex flex-col items-center justify-center py-24 text-center">
      <p className="text-7xl font-extrabold text-primary">404</p>
      <h1 className="mt-4 text-2xl font-bold">Page Not Found</h1>
      <p className="mt-2 max-w-sm text-sm text-slate-600">
        Whoops — the page you were looking for doesn't exist or has been
        moved.
      </p>
      <div className="mt-8 flex gap-4">
        <Link to="/" className="btn-primary">
          Back to Home
        </Link>
        <Link to="/contact" className="btn-outline">
          Contact Support
        </Link>
      </div>
    </section>
  );
}
